<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>
	
<style>
	video{
	   object-fit:cover;  
	}
	/* .vjs-custom-skin > .video-js {
	    padding-top: 39.4% !important;
		width: 70% !important;
	} */
    /*@import "./assets/css/main.css";
    @import "./assets/css/color-dark.css";
    @import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>



// WEBPACK FOOTER //
// src/App.vue